import { AxiosClient } from '@/app/shared/services';

const state = {
    templatesList: {
        list: [],
        isLoading: false,
    },
    notification_template:{
        name: null,
        type: null,
        linked_notifications_info : []
    },
    modals: {
        create_template: false,
    },
};

const getters = {
    TEMPLATES_LOADING: (state) => state.templatesList.isLoading,
    TEMPLATES_LIST: (state) => state.templatesList.list,
    TEMPLATE_NOTIFICATION: (state) => state.notification_template,
    IS_CREATE_MESSAGE_TEMPLATE_MODAL_IS_OPENED: (state) => state.modals.create_template,
};

const mutations = {
    SET_TEMPLATES_LIST: (state, settings) => {
        state.templatesList.list = settings;
    },
    SET_TEMPLATES_LOADING: (state, isLoading) => {
        state.templatesList.isLoading = isLoading;
    },
    SET_CURRENT_TEMPLATE_NOTIFICATION: (state, notification_template) => {
        state.notification_template = notification_template;
    },
    SET_CREATE_TEMPLATE_MODAL_IS_OPENED: (state, isOpened) => {
        state.modals.create_template = isOpened;
    },
};

const actions = {
    GET_TEMPLATES_LIST: (context, params) => {
        context.commit('SET_TEMPLATES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/notification_templates/get', {params})
                .then((response) => {
                    context.commit('SET_TEMPLATES_LIST', response.data);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit('SET_TEMPLATES_LOADING', false);
                });
        });
    },

    GET_TEMPLATE_NOTIFICATION_BY_ID: (context, templateId) => {
        context.commit('SET_TEMPLATES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/notification_templates/get/${templateId}`)
                .then((data) => {
                    context.commit('SET_CURRENT_TEMPLATE_NOTIFICATION', data.data);
                    resolve(data.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_TEMPLATES_LOADING', false);
                });
        });
    },

    CREATE_TEMPLATE_NOTIFICATION: (context, template) => {
        context.commit("SET_TEMPLATES_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/notification_templates/create`, template)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_TEMPLATES_LOADING", false);
                });
        });
    },

    UPDATE_TEMPLATE_NOTIFICATION: (context, template) => {
        context.commit("SET_TEMPLATES_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/notification_templates/update/${template.id}`, template)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_TEMPLATES_LOADING", false);
                });
        });
    },

    DELETE_TEMPLATE_NOTIFICATION: (context, id) => {
        return new Promise((resolve, reject) => {
            AxiosClient.post('/notification_templates/delete/' + id)
                .then(() => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
        })
    },

    RESET_CURRENT_TEMPLATE_NOTIFICATION: (context) => {
        context.commit("SET_CURRENT_TEMPLATE_NOTIFICATION", {
            name: null,
            type: null,
            linked_notifications_info : []
        });
    },

    CREATE_TEMPLATE_MODAL: (context, isOpen) => {
        context.commit("SET_CREATE_TEMPLATE_MODAL_IS_OPENED", isOpen);
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
